import { getTabContentList } from '@/api';
export const field = ['tabs', 'currentId'];
export default {
  namespaced: true,
  state: {
    tabs: {},
    currentId: '',
  },
  mutations: {
    SET_tabs(state, data) {
      state.tabs = { ...state.tabs, ...data };
    },
    SET_currentTab(state, { key, data }) {
      if (data.list && data.list.length > 0) {
        state.tabs[key].list.push(...data.list);
      }
      const param = { ...data };
      delete param.list;
      state.tabs[key] = { ...state.tabs[key], ...param };
    },
    SET_currentId(state, id) {
      state.currentId = id;
    },
    SET_refresh(state, key) {
      const tab = {
        isFinished: false,
        list: [],
        refreshing: false,
        isError: false,
        pageNo: 0,
      };
      state.tabs[key] = { ...state.tabs[key], ...tab };
    },
  },
  actions: {
    async getList({ commit }, params) {
      commit('SET_currentTab', {
        key: `tabId${params.tabId}`,
        data: { isLoading: true, isError: false },
      });
      const tab = {};
      try {
        const { data = [] } = await getTabContentList(params);
        if (data.length < 20) {
          tab.pageNo = 0;
        }
        if (params && params.tabId) {
          tab.list = data;
          if (tab.list.length === 0) {
            tab.isError = true;
            tab.errorType = 'empty';
          }
        }
      } catch (error) {
        const { response = null } = error;
        tab.isError = true;
        // }
        if (response && response.status >= 500) {
          tab.errorType = 'server';
          return;
        }
        tab.errorType = 'network';
      } finally {
        tab.isLoading = false;
        commit('SET_currentTab', { key: `tabId${params.tabId}`, data: tab });
      }
    },
  },
};
